import { Box } from "@material-ui/core"
import { standardScrollBar } from "../../../styles"
import { ReactNode } from "react"

export function DetailsTableRootLayout({ children }: { children: ReactNode }) {
  return (
    <Box
      style={{ width: "100%", overflow: "auto" }}
      className={standardScrollBar.root}
    >
      {children}
    </Box>
  )
}
